import React from 'react';
import PropTypes from 'prop-types';
import CalloutValue from 'common/components/callout-value';
import './index.scss';

/**
 * CalloutBox
 */
function CalloutBox(props) {
  const {values} = props;
  return (
    <div className={'CalloutBox'}>
      {values.map((obj, index) => {
        return (
          <CalloutValue
            key={`CalloutBox-CalloutValue-${index}`}
            label={obj.label}
            suffix={obj.suffix}
            tooltip={obj.tooltip}
            value={obj.value}
          />
        );
      })}
    </div>
  );
}

CalloutBox.propTypes = {
  values: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      suffix: PropTypes.string,
      tooltip: PropTypes.string,
      value: PropTypes.any,
    }),
  ).isRequired,
};
CalloutBox.defaultProps = {
  values: [],
};

export default CalloutBox;
